export const onVisibleZindex = 99;
export const headerZindex = 100;
export const headerMenuZindex = 101;
export const headerCtasZindex = 102;
export const blogContentZindex = 9;
